import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EntityGroupDetailsService } from '../../entity-group-details.service';
import { ActivatedRoute } from '@angular/router';
import { AppManualAdjustmentModalComponent } from '../app-wallet-manual-adjustment/app-manual-adjustment-modal/app-manual-adjustment-modal.component';
import { IosNativeSupportSyncModalComponent } from './ios-native-support-sync-modal/ios-native-support-sync-modal.component';

@Component({
  selector: 'app-ios-native-support-sync',
  templateUrl: './ios-native-support-sync.component.html',
  styleUrls: ['./ios-native-support-sync.component.scss'],
  standalone: false,
})
export class IosNativeSupportSyncComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    private entityGroupService: EntityGroupDetailsService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {}

  openModal(): void {
    this.dialog
      .open(IosNativeSupportSyncModalComponent, { data: {}, height: '90vh', disableClose: true })
      .afterClosed()
      .subscribe(() => {
        this.entityGroupService.reloadSubject.next(this.route.snapshot.paramMap);
      });
  }
}
